/**
 * Browser-specific Number prototype extensions
 *
 * Platform-agnostic extensions are imported from switch-core.
 * This file imports them and can add web-specific extensions if needed.
 */

// Import platform-agnostic extensions from switch-core
import "../../core_bridge/switch-core/extensions/number";

// Note: All number extensions are platform-agnostic and live in switch-core.
// This file exists for browser-specific extensions if needed in the future.

console.log("[extensions/number] browser extensions loaded");
